import { Component, OnInit, effect, inject } from '@angular/core';
import { PoliticasEntregaStore } from '../../../stores/politicas-entrega.store';
import { PoliticaEntregaApiService } from '../../../services/politica-entrega-api.service';
import { PoliticasEntregaUiEffectsService } from '../ui-effects/politicas-entrega-ui-effects.service';

@Component({
  selector: 'app-politicas-entrega-page',
  templateUrl: './politicas-entrega-page.component.html',
  styleUrls: ['./politicas-entrega-page.component.css'],
  providers: [PoliticaEntregaApiService, PoliticasEntregaStore, PoliticasEntregaUiEffectsService],
})
export class PoliticasEntregaPageComponent implements OnInit {
  readonly store = inject(PoliticasEntregaStore);
  private readonly uiEffects = inject(PoliticasEntregaUiEffectsService);

  constructor() {
    effect(() => {
      this.uiEffects.syncLoading(this.store.loading());
    });
  }

  ngOnInit(): void {
    this.store.loadRegiones().subscribe({
      next: () => {
        this.store.buscarPoliticas().subscribe({
          error: () => {
            this.uiEffects.showPoliticasLoadError();
          },
        });
      },
      error: () => {
        this.uiEffects.showRegionesLoadError();
      },
    });
  }
}
